define('views/components/blacklist_user/user',['require','backbone','text!templates/components/blacklist_user/user.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/blacklist_user/user.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'user-item',

        ui: function() {
            return {
                unblockButton: '#unblock-button'
            };
        },

        events: {
            'click @ui.unblockButton': 'unblockButtonClicked'
        },

        unblockButtonClicked: function () {
            var _this = this;

            $.ajax({
                url: App.Config.apiBase + 'users/' + this.model.get('id') + '/unblock/',
                method: 'post',
                success:function(response) {
                    _this.model.collection.remove(_this.model);

                    App.utils.showMessage('success', App.polyglot.t('unblock_success'));
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    // Show error messages
                    if (xhr.responseJSON.errors) {
                        for (var i=0; i<xhr.responseJSON.errors.length; i++) {
                            App.utils.showMessage('error', xhr.responseJSON.errors[i].message);
                        }
                    }
                }
            });
        }
    });
});
